export const getManufacturerHighlightName = product => {
    const getField = name => product?.[Object.keys(product || {}).find(key => key.toLowerCase() === name.toLowerCase())];
    const sellerTypes = ['UserTypeName', 'VendorTypeName', 'SellerTypeName']
        .map(key => String(getField(key) || '').toLowerCase().replace(/[^a-z]/g, ''))
        .filter(Boolean);
    if (!sellerTypes.some(type => type.includes('manufacturer'))) return '';
    if (sellerTypes.some(type => /supplier|reseller|hardware|hardshop/.test(type))) return '';
    return String(getField('ManufacturerName') || '').trim();
};
